import React from 'react'

import Button from '../Button/Button'
import {createUrlsParamBasedOnCookies} from '../../../utils/Utm'

const redirectToRegister = () => {
    window.location = `https://app.mercos.com/cadastro/${createUrlsParamBasedOnCookies()}`
}

const TrialButton = ({ purple, size }) => (
    <Button purple={purple} size={size} onClick={() => redirectToRegister()} radius='half-rounded'>TESTE GRÁTIS</Button>
)

export default TrialButton



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/TryIt/TrialButton.jsx